import { useState, useEffect } from 'react'
import { RegaliaUxConstants } from '../components/regalia-ux'

export const useGetRegaliaUxDialogData = (activeCatalogOsr, catalogs, isRegaliaDialogVisible) => {
    const [data, setData] = useState()

    useEffect(()=>{
        const activeCatalog = catalogs.find(catalog => catalog.catalogOsr === activeCatalogOsr)
        if (!isRegaliaDialogVisible && data) {
            // drop data when dialog is closed
            setData(undefined)
            return
        }

        if (activeCatalog) {
            // take only unique catalogOsrs for Consumer Type Step 
            const consumerTypeStep = [... new Set(activeCatalog.subCatalogs.map(subCatalog => subCatalog.catalogOsr))]
            
            // create required data schema for Catalog Step 
            let catalogStepInitialData = Object.fromEntries(consumerTypeStep.map(element => [element, []]))
            const catalogStep = activeCatalog.subCatalogs.reduce((acc, subCatalog) => {
                acc[subCatalog.catalogOsr].push({
                    label: subCatalog.displayName,
                    value: subCatalog.publishedCatalogId
                })
                return acc
            }, catalogStepInitialData)
            
            const preparedStepData = {
                [RegaliaUxConstants.CONSUMER_TYPE_STEP]: consumerTypeStep,
                [RegaliaUxConstants.CATALOG_STEP]: catalogStep
            }

            setData({ catalogActionUrl: activeCatalog.actionUrl, stepsData: preparedStepData })
        } 

    }, [activeCatalogOsr, isRegaliaDialogVisible])

    return data
}